<template>
 <Dialog v-model:visible="visible" modal :header="$t('paymentCompleted')" :style="{ width: '30rem' }">
    <div class="flex flex-col items-center text-center p-5">
      <i class="pi pi-check-circle text-green-500 text-6xl mb-4"></i>
      <h2 class="text-2xl font-semibold text-gray-800">{{ $t('thankYou') }}</h2>
      <p class="text-gray-600 mt-2">
        {{ $t('paymentSuccess') }}
      </p>
    </div>
    <template #footer>
      <Button :label="$t('close')" icon="pi pi-times" @click="visible = false" severity="secondary" />
    </template>
  </Dialog>
</template>


<script>

export default {
    data() {
        return {
            visible: false,
        };
    },
    methods: {
        showDialog() {
            this.visible = true;
        },
    }
}

</script>
